import { configureStore as configureToolkitStore } from '@reduxjs/toolkit'
import rootReducer from '../reducers'
import { persistReducer, persistStore } from 'redux-persist'
import { reduxPersistConfig } from 'galarm-config'
import { Platform } from 'react-native'
import { GlobalConfig } from 'galarm-config'
import {
  StorageManager,
  NotificationManager,
  AlarmManager
} from 'galarm-ps-api'

export default function configureStore() {
  const persistedReducer = persistReducer(reduxPersistConfig, rootReducer)

  const store = configureToolkitStore({
    reducer: persistedReducer,
    middleware: getDefaultMiddleware => {
      return getDefaultMiddleware({
        serializableCheck: __DEV__
          ? {
              ignoredActions: [
                'persist/PERSIST',
                'persist/REHYDRATE',
                'persist/PURGE'
              ]
            }
          : false
      })
    },
    devTools: __DEV__ // Use built-in Redux DevTools instead of Reactotron for web
  })

  const persistor = persistStore(store)
  return { store, persistor }
}

export function purgeStateIfReducerVersionChanged(persistor) {
  return StorageManager.retrieveData(['reducerVersion']).then(data => {
    const reducerVersion = data.reducerVersion
    if (reducerVersion !== GlobalConfig.reducerVersion) {
      console.log(
        'Reducer version change ' +
          reducerVersion +
          ' ' +
          GlobalConfig.reducerVersion
      )

      persistor.purge()
      StorageManager.storeData({
        reducerVersion: GlobalConfig.reducerVersion
      })
      Platform.OS === 'android' && NotificationManager.cancelAllNotifications()
      AlarmManager.cancelAllNotifications()
    }
  })
}
